import {
    AnyAction,
    ListenerEffectAPI,
    UnsubscribeListener,
} from '@reduxjs/toolkit'
import {
    AppDispatch,
    RootState,
} from '../../store'
import {NinchatClientPromiseValue} from '../../api/NinchatClient'

export type EffectArgs = {
    action: AnyAction
    listenerApi: ListenerEffectAPI<RootState, AppDispatch>
}

export type EffectProcessArgs = {
    flushNotificationQueue: () => void
    ignoreIdle?: boolean
    listener?: Listener
    notificationQueue: NotificationQueueEntry[]
} & EffectArgs

export type EffectRetval = [NotificationType, NinchatClientPromiseValue]

export type Listener = {
    effects: Map<NotificationKey, (args: EffectArgs) => EffectRetval>
    unsubscribe: UnsubscribeListener
}

export type NotificationEvent = {
    audio?: boolean
    channel_name?: string
    desktop?: boolean
    message?: string
    queue_name?: string
    realm_name?: string
    type: NotificationType
    user_name?: string
}

export type NotificationKey =
    'ignore_idle' | 'require_interaction' |
    'private' | 'highlight' | 'channel_join' | 'channel' | 'audience_queue' | 'audience_queue_picked' | 'audience' | 'audience_register' |
    'private_audio' | 'highlight_audio' | 'channel_join_audio' | 'channel_audio' | 'audience_queue_audio' | 'audience_queue_picked_audio' | 'audience_audio' | 'audience_register_audio'

export type NotificationQueueEntry = {
    audio: boolean
    desktop: boolean
    payload: NinchatClientPromiseValue
    type: NotificationType
}

export enum NotificationType {
    MessageReceivedChannel = 'message_received/channel',
    MessageReceivedChannelAudience = 'message_received/channel/audience',
    MessageReceivedChannelJoin = 'message_received/channel/join',
    MessageReceivedDialogue = 'message_received/dialogue',
    QueueActivity = 'queue_activity',
    QueueUpdatedAudienceAcceptPeer = 'queue_updated/audience_accept_peer',
    QueueUpdatedAudienceRequest = 'queue_updated/audience_request',
}
